import { initFederation } from '@angular-architects/native-federation';

import {
  isChunkLoadError,
  reloadForChunkError,
} from './app/modules/core/handlers/chunk-load-error';

// Chunk-load failures can occur before Angular bootstraps, so they bypass
// Angular's error handlers. Reload silently to recover from stale chunks
// after a deployment.
window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    // Only suppress the rejection when we actually recover (reload/back-nav).
    // If reloadForChunkError gives up (e.g. the reload-window guard), let the
    // rejection surface so it is still logged instead of silently swallowed.
    const handled = reloadForChunkError();
    if (handled) {
      event.preventDefault();
    }
  }
});

const federationManifestUrl = new URL(
  'Content/assets/federation.manifest.json',
  document.baseURI,
).toString();

initFederation(federationManifestUrl, { deployUrl: '/' })
  .catch((err) => console.error(err))
  .then(() => import('./bootstrap'))
  .catch((err) => console.error(err));
